import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import { Button } from 'app/src/elements/buttons';

import { cardStyles as styles } from './index';

const WebsiteBuyersReport = ({ data }) => {
  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'website-buyers-report',
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Website Buyers Report</Text>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default WebsiteBuyersReport;
